import { Link } from "react-router-dom";
import { tagPath } from "../../lib/slug";

type TagListProps = {
  tags: string[];
};

export function TagList({ tags }: TagListProps) {
  if (tags.length === 0) return null;

  return (
    <ul className="tag-list" aria-label="Article tags">
      {tags.map((tag) => (
        <li key={tag}>
          <Link to={tagPath(tag)}>{tag}</Link>
        </li>
      ))}
    </ul>
  );
}
